module.exports = __webpack_public_path__ + "2d35b4d1.svg";